document.addEventListener("click", function(e)
{
  var target = e.target;

  while(target && (target.tagName !== "BUTTON" || !target.classList.contains("js-dropdown-menu-btn")))
    target = target.parentNode;

  if(target == null)
  {
    const allDropdowns = document.querySelectorAll('.js-dropdown-menu-btn');

    allDropdowns.forEach((item) =>
    {
      const dropdownMenu = item.nextElementSibling;
      dropdownMenu.classList.remove('js-active');
    });

    return;
  }

  target.nextElementSibling.classList.toggle("js-active");
});